<template>
  <div class="rso-mini-table-wrap">
    <table
      class="rso-mini-table rso-smeta-grid-table"
      lang="ru"
    >
      <colgroup>
        <col
          v-for="c in RESIDENT_SMETA_GRID_COLS"
          :key="c.key"
          :style="{ width: c.width }"
        />
      </colgroup>
      <tbody>
        <tr
          v-for="(row, idx) in rows"
          :key="`mat-${nodeId}-${idx}`"
          class="rso-mat-row"
          :class="{ 'rso-mat-row--alt': idx % 2 === 1 }"
        >
          <td class="tw-text-left rso-mat-row-title">
            <span
              class="rso-mat-row-title-text"
              :style="{ paddingLeft: `${titleIndentPx}px` }"
            >{{ row.mname || "—" }}</span>
          </td>
          <td class="tw-text-left rso-mat-cell">{{ row.munt || "—" }}</td>
          <td class="tw-text-right rso-mat-cell rso-mat-cell--num">{{ formatNum(row.mqty) }}</td>
          <td class="tw-text-right rso-mat-cell rso-mat-cell--num">{{ formatNorm(row.norm_ratio) }}</td>
          <td class="tw-text-right rso-mat-cell rso-mat-cell--num">
            <Amount
              v-if="hasCostAmount(row.mprc_no_nds)"
              :value="row.mprc_no_nds"
              :round="2"
            />
            <span v-else class="rso-empty">—</span>
          </td>
          <td class="tw-text-right rso-mat-cell rso-mat-cell--cost rso-empty">—</td>
          <td class="tw-text-right rso-mat-cell rso-mat-cell--cost rso-mat-cell--num">
            <Amount
              v-if="hasCostAmount(row.msum_line_no_nds)"
              :value="row.msum_line_no_nds"
              :round="2"
            />
            <span v-else class="rso-empty">—</span>
          </td>
          <td class="tw-text-right rso-mat-cell rso-mat-cell--cost rso-empty">—</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import Amount from "@/components/common/Amount.vue";
import { RESIDENT_SMETA_GRID_COLS } from "../residentSmetaGridColumns.js";

defineProps({
  rows: {
    type: Array,
    default: () => [],
  },
  nodeId: {
    type: String,
    required: true,
  },
  titleIndentPx: {
    type: Number,
    default: 52,
  },
});

function formatNum(v) {
  if (v == null || v === "") return "—";
  const n = Number(v);
  if (Number.isNaN(n)) return "—";
  return String(n);
}

function formatNorm(v) {
  if (v == null || v === "") return "—";
  const n = Number(v);
  if (Number.isNaN(n) || n <= 0) return "—";
  return n.toFixed(3);
}

function hasCostAmount(v) {
  if (v == null || v === "") return false;
  const n = Number(v);
  return !Number.isNaN(n);
}
</script>

<style scoped lang="scss">
.rso-mini-table-wrap {
  width: 100%;
  box-sizing: border-box;
  padding: 2px 0 10px;
  background: #e9f1fb;
  border-bottom: 1px solid #b8cfe4;
}

.rso-mini-table {
  width: 100%;
}

.rso-mat-row,
.rso-mat-row--alt {
  background: #e9f1fb;
  transition: background-color 0.12s ease;
}

.rso-mat-row:hover,
.rso-mat-row--alt:hover {
  background: #e9f1fb;
}

.rso-mat-cell {
  font-size: 12px;
  color: #0f172a;
}

.rso-mat-cell--num {
  font-variant-numeric: tabular-nums;
}

.rso-mat-cell--cost {
  background: #e9f1fb;
}

.rso-empty {
  color: #94a3b8;
}

.rso-mini-table tbody tr.rso-mat-row td {
  min-height: 34px;
  padding-top: 5px;
  padding-bottom: 5px;
  vertical-align: middle;
  box-sizing: border-box;
  line-height: 1.35;
}

.rso-mat-row-title-text {
  display: block;
  box-sizing: border-box;
  max-width: 100%;
  font-size: 12px;
  font-weight: 400;
  color: #2563eb;
  line-height: 1.35;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}
</style>
